import React from 'react'
import type { AriaProps } from '../../../types'
import { BaseActionBarButton } from '../BaseActionBarButton'
import { useButtonProps } from '../../hooks'

export type ActionBarIconButtonPublicProps = {
  ariaProps?: AriaProps
  'data-id'?: string
  'data-test-id'?: string
  icon: React.ComponentType
  isDisabled?: boolean
  label: string
  onClick: () => void
  INTERNAL_hasNextSibling?: boolean
  INTERNAL_isOnlyChild?: boolean
}

export const ActionBarIconButton = ({
  isDisabled,
  'data-id': dataId,
  'data-test-id': dataTestId,
  icon,
  label,
  onClick,
  ariaProps,
  INTERNAL_hasNextSibling,
  INTERNAL_isOnlyChild,
}: ActionBarIconButtonPublicProps) => {
  const { ref, buttonProps } = useButtonProps({
    onClick,
    type: 'button',
    isDisabled,
    'aria-label': label,
    ...ariaProps,
  })
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { children, ...rest } = buttonProps

  return (
    <BaseActionBarButton
      variant='minor'
      wrapper={{ as: 'button', ref }}
      data-id={dataId}
      data-test-id={dataTestId}
      startIcon={icon}
      INTERNAL_hasNextSibling={INTERNAL_hasNextSibling}
      INTERNAL_isOnlyChild={INTERNAL_isOnlyChild}
      {...rest}
    />
  )
}
